import { FC, useCallback, useRef } from 'react';
import Webcam from 'react-webcam';
import Button from '../button/button';
import CloseIcon from '../../assets/closeIcon.svg';
import { CameraProps, defaultVideoConstraints } from './type';

const Camera: FC<CameraProps> = ({
  videoConstraints = defaultVideoConstraints,
  onCapture,
  onClose,
}) => {
  const webcamRef = useRef<Webcam>(null);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current?.getScreenshot();
    if (imageSrc) {
      onCapture(imageSrc);
    }
  }, [onCapture]);

  return (
    <div className="w-full h-full">
      <Button
        onClick={onClose}
        className="absolute top-0 right-0  flex items-center justify-center text-white z-10 bg-transparent"
      >
        <img
          src={CloseIcon}
          alt="Close"
          className="w-100 h-100"
          height={47}
          width={47}
        />
      </Button>
      <div className="relative h-[88vh] flex flex-col items-center justify-center bg-[#120000] m-10">
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={videoConstraints}
          className="w-full h-full object-cover rounded-[10px]"
        />
        <div className="absolute bottom-8 w-full flex justify-center">
          <button
            onClick={capture}
            className="w-16 h-16 rounded-full bg-white flex items-center justify-center"
          >
            <div className="w-12 h-12 rounded-full border-2 border-gray-300"></div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Camera;
